import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { getCardBackImage } from '../../common';
import userById from '../../common/helpers/userById';
export default class ArenaBattleWaitPost extends Component {
  view() {
    var _userById, _userById2;
    const data = this.attrs.post.content();
    if (!data) return null;
    const turn = data.turn,
      playerName = data.playerName,
      waitingForName = data.waitingForName,
      playerId = data.playerId,
      waitingForId = data.waitingForId;
    const playedBack = getCardBackImage((_userById = userById(playerId)) == null ? void 0 : _userById.attribute('arenaCardBack'));
    const facedownBack = getCardBackImage((_userById2 = userById(waitingForId)) == null ? void 0 : _userById2.attribute('arenaCardBack'));
    return m("div", {
      className: "ArenaTurnPost ArenaWaitPost EventPost"
    }, m("div", {
      className: "ArenaTurnPost-heading"
    }, m("i", {
      className: "fas fa-dungeon"
    }), m("span", null, app.translator.trans('forumaker-arena.forum.battle.turn_heading', {
      turn: String(turn)
    }))), m("div", {
      className: "ArenaTurnPost-cards"
    }, m("div", {
      className: "ArenaWaitPost-col"
    }, m("div", {
      className: "ArenaTurnPost-cardLabel"
    }, playerName), m("div", {
      className: "ArenaTurnPost-card ArenaWaitPost-played"
    }, m("div", {
      className: "ArenaTurnPost-cardInner ArenaWaitPost-cardInner"
    }, m("div", {
      className: "ArenaTurnPost-cardHeader ArenaWaitPost-cardBack ArenaWaitPost-cardBack--played".concat(playedBack ? ' ArenaWaitPost-cardBack--skinned' : ''),
      style: playedBack ? {
        '--arena-card-back-image': "url(".concat(playedBack, ")")
      } : undefined
    }, !playedBack && m("i", {
      className: "fas fa-check"
    })), m("div", {
      className: "ArenaTurnPost-cardBody"
    }, m("div", {
      className: "ArenaTurnPost-cardName",
      style: {
        justifyContent: 'center',
        fontSize: '.85em',
        color: 'var(--muted-color)'
      }
    }, app.translator.trans('forumaker-arena.forum.battle_wait.played')))))), m("div", {
      className: "ArenaTurnPost-vs"
    }, "VS"), m("div", {
      className: "ArenaWaitPost-col"
    }, m("div", {
      className: "ArenaTurnPost-cardLabel"
    }, waitingForName), m("div", {
      className: "ArenaTurnPost-card ArenaWaitPost-facedown"
    }, m("div", {
      className: "ArenaTurnPost-cardInner ArenaWaitPost-cardInner"
    }, m("div", {
      className: "ArenaTurnPost-cardHeader ArenaWaitPost-cardBack".concat(facedownBack ? ' ArenaWaitPost-cardBack--skinned' : ''),
      style: facedownBack ? {
        '--arena-card-back-image': "url(".concat(facedownBack, ")")
      } : undefined
    }, !facedownBack && m("i", {
      className: "fas fa-question"
    })), m("div", {
      className: "ArenaTurnPost-cardBody"
    }, m("div", {
      className: "ArenaTurnPost-cardName ArenaWaitPost-dots"
    }, m("span", null, "\xB7"), m("span", null, "\xB7"), m("span", null, "\xB7"))))))), m("div", {
      className: "ArenaWaitPost-status"
    }, m("i", {
      className: "fas fa-hourglass-half"
    }), app.translator.trans('forumaker-arena.forum.battle_wait.waiting', {
      name: m("strong", null, waitingForName)
    })));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleWaitPost', ArenaBattleWaitPost);